





















import {
  Component, Vue, Provide, Prop,
} from 'vue-property-decorator';
import {
  Button,
  Table,
  TableColumn,
  Scrollbar,
  Message,
  DatePicker,
} from 'element-ui';
import Read from '@/servers/modules/read/read';
// server
@Component({
  components: {
    Table,
    TableColumn,
  },
})
export default class extends Vue {
  private startTime: any = '';

  private endTime: any = '';

  private pageNum: number = 0;

  private lock:boolean = false

  private tableHeaderClassName() {
    return 'table-header';
  }

  private tableRowClassName() {
    return 'table-row';
  }

  private tableData: any = [];

  // ----------------初始化
  private async initLoad(startTime: string, endTime: string) {
    this.startTime = startTime;
    this.endTime = endTime;
    // 由父组件传输来的 数据进行清空并请求接口
    this.pageNum = 0;
    this.tableData = [];
    this.init();
  }

  private async init() {
    if (this.lock) {
      return false;
    }
    this.lock = true;
    this.pageNum = ++this.pageNum;
    console.log('this.pageNum', this.pageNum);
    const form: any = {
      courseId: window.LS.get('basicData').courseId,
      pageNum: this.pageNum,
      pageSize: 20,
    };
    if (this.startTime) {
      form.startTime = new Date(this.startTime).getTime();
    }
    if (this.endTime) {
      form.endTime = new Date(this.endTime).getTime();
    }

    const res = await Read.queryStudyRecordList(form).catch((e: any) => {
      console.log(e);
    });
    if (res.data.code == 0) {
      const temparr = res.data.data.records || [];

      if (this.pageNum == 1) {
        this.tableData = temparr;
      } else {
        this.tableData = this.tableData.concat(temparr);
      }
      console.log(this.tableData);

      this.lock = false;
    }
  }


  private async load() {
    this.init();
  }
}
